import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  FaChevronLeft,
  FaChevronRight,
  FaHeart,
  FaRegComment,
} from "react-icons/fa6";

interface PostProps {
  profileImage: string;
  username: string;
  images: string[];
  caption: string;
  captionDetail: string;
  swiperId: string; // 각 Swiper를 구분할 수 있도록 swiperId 추가
}

const InstaFeed: React.FC<PostProps> = ({
  profileImage,
  username,
  images,
  caption,
  captionDetail,
  swiperId,
}) => {
  const [isFirstSlide, setIsFirstSlide] = useState(true); // 첫 번째 슬라이드인지 확인
  const [isLastSlide, setIsLastSlide] = useState(false); // 마지막 슬라이드인지 확인

  const handleSlideChange = (swiper: any) => {
    // 첫 번째 슬라이드인지 확인
    setIsFirstSlide(swiper.isBeginning);
    // 마지막 슬라이드인지 확인
    setIsLastSlide(swiper.isEnd);
  };

  return (
    <div className="max-w-md bg-white mb-6 mx-2 font-gowun">
      {/* 프로필 & 닉네임 */}
      <div className="flex items-center mb-3">
        <div className="w-10 h-10 rounded-full p-0.5">
          <img
            src={profileImage}
            alt={username}
            className="w-full h-full object-cover rounded-full"
          />
        </div>
        <span className="ml-1 font-semibold">{username}</span>
      </div>

      {/* 이미지 슬라이더 */}
      <div className="relative -mx-2">
        <Swiper
          modules={[Navigation, Pagination]}
          navigation={{
            nextEl: `#${swiperId}-next`,
            prevEl: `#${swiperId}-prev`,
          }}
          pagination={{ clickable: true }}
          onSlideChange={handleSlideChange} // 슬라이드 변경 시 상태 업데이트
          className="overflow-hidden h-full"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              {/* SwiperSlide 안에 flex 컨테이너를 사용해 중앙 정렬 */}
              <div className="flex justify-center items-center h-full w-full">
                <img
                  src={image}
                  alt={`Post ${index + 1}`}
                  className="object-contain max-h-full max-w-full rounded-md"
                  style={{ aspectRatio: "0.8" }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* 커스텀 네비게이션 버튼 */}
        <button
          id={`${swiperId}-prev`}
          className={`absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full z-10 ${
            isFirstSlide ? "hidden" : ""
          }`} // 첫 번째 슬라이드에서 왼쪽 버튼 숨기기
        >
          <FaChevronLeft fontFamily="bold" size={12} />
        </button>
        <button
          id={`${swiperId}-next`}
          className={`absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full z-10 ${
            isLastSlide ? "hidden" : ""
          }`} // 마지막 슬라이드에서 오른쪽 버튼 숨기기
        >
          <FaChevronRight fontFamily="bold" size={12} />
        </button>
      </div>

      {/* 하트 & 댓글 아이콘 */}
      <div className="flex items-center space-x-4 mt-3">
        <FaHeart className="text-red-500 text-xl cursor-pointer" />
        <FaRegComment className="text-gray-600 text-xl cursor-pointer" />
      </div>

      {/* 한 줄 글귀 */}
      <p className="mt-2 text-sm text-left">
        <strong>{username}</strong> {caption}
      </p>
      <div className="mt-1 text-sm text-left text-gray-500">
        {captionDetail}
      </div>
    </div>
  );
};

export default InstaFeed;
